import React from 'react';
import {
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export default function TaskHistoryTab({ history }) {
  if (history.length === 0) {
    return <Alert severity="info">No history found for this task.</Alert>;
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Action by</TableCell>
            <TableCell>Action</TableCell>
            <TableCell>Message</TableCell>
            <TableCell>Created at</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {history.map((item, index) => (
            <TableRow key={item?.id ?? index}>
              <TableCell>{item?.author?.name ?? item?.user?.name ?? '—'}</TableCell>
              <TableCell>{item?.status?.action ?? item?.action ?? '—'}</TableCell>
              <TableCell>{item?.message ?? '—'}</TableCell>
              <TableCell>{item?.created_at ?? '—'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
